module.exports = __webpack_public_path__ + "media/cash.af0f389e.mp3";